import SearchIcon from '@upright/ui/common/generic/components/icons/hero-icons/hi-magnifying-glass.svg';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { components, ValueContainerProps } from 'react-select';
import styled, { css } from 'styled-components';
import { ModelEntitySearchResponseItem } from '../../../../../../../../common/model/search/types';
import { BouSpacingLevel, fluidVerticalPadding } from '../../../../../../generic/layout/bou-spacing';
import { mobileOrNarrower } from '../../../../../../generic/layout/breakpoint-utils';

export function HeaderSearchValueContainer(props: ValueContainerProps<ModelEntitySearchResponseItem, false>) {
  return (
    <components.ValueContainer {...props}>
      <Main>
        <Icon />
        <ChildContainer>{props.children}</ChildContainer>
      </Main>
    </components.ValueContainer>
  );
}

const Main = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  ${mobileOrNarrower(
    css`
      ${fluidVerticalPadding(BouSpacingLevel.TINY)}
    `,
  )}
`;

const ChildContainer = styled.div`
  display: flex;
  align-items: center;
  input {
    color: ${BouColor.PLATFORM_TEXT_WHITE} !important;
  }
`;

const Icon = styled(SearchIcon)`
  margin-right: 8px;
  height: 14px;
`;
